// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__k-wYu","content":"styles_content__2KQfH"};